import { Component } from 'vue-property-decorator';
import type { CreateElement, VNode } from 'vue';
import moment from 'moment';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

@DialogFactory
@Component({})
export default class updatePrice extends IPSDialog {
  /**
   * 外部传入
   * @protected
   */
  // 数据

  public item: any = null;

  public siteId = 0;

  top = '25vh';
  width = '900px';
  footer = false;

  /**
   * 内部变量
   * @protected
   */

  public isProcess = false;

  public status = '';

  public loading = false;

  successNum = 0;

  failedNum = 0;

  errorReason = [];
  updateTime = '';

  update() {
    if (this.item === '') {
      this.$message.error('请填写商品货号！');
    } else {
      if (this.item.split(',').length > 2000) {
        this.$message.error('放置商品货号已超过2000个');
      } else {
        this.loading = true;
        const postParams = {
          siteId: this.siteId,
          productCodes: this.item.split(','),
        };
        IPSService.productChangePrice({
          postParams,
        })
          .then((res) => {
            this.isProcess = true;
            this.status = '数据更新请求已提交，请稍后确认更新结果！';
            this.$emit('result', this.item);
            // }
          })
          .catch((err1) => {
            this.loading = false;
            this.isProcess = true;
            this.status = err1.message;
          });
      }
    }
  }

  close() {
    this.dialogShow = false;
    setTimeout(() => {
      this.$emit('hidden', this.item);
    });
  }

  mounted() {
    IPSService.productChangeCheck({
      postParams: { siteId: this.siteId },
    }).then((res) => {
      if (res.cacheCodes === '') {
        this.loading = false;
        if (res.lastJobContent) {
          this.successNum
            = res.lastJobContent.successProducts.length > 0
              ? res.lastJobContent.successProducts
                .map(i => i.productCodes)
                .filter(Boolean)
                .join(',')
                .split(',').length
              : 0;
          this.failedNum
            = res.lastJobContent.errorProducts.length > 0
              ? res.lastJobContent.errorProducts
                .map(i => i.productCodes)
                .filter(Boolean)
                .join(',')
                .split(',').length
              : 0;
          this.updateTime = moment(res.lastJobContent.time * 1000).format('YYYY-MM-DD HH:mm');
          this.errorReason
            = res.lastJobContent.errorProducts.length > 0
              ? res.lastJobContent.errorProducts
                .map((i) => {
                  return i.productCodes
                    .split(',')
                    .map((code) => {
                      if (i.productCodes.includes(code)) {
                        return { productCode: code, content: i.content };
                      }
                    })
                    .filter(Boolean);
                })
                .flat(Number.POSITIVE_INFINITY)
              : [];
        }
      } else {
        this.loading = true;
        this.item = res.cacheCodes;
        this.isProcess = true;

        this.status = '商品正在更新，请稍后确认更新结果';
      }
    });
  }

  onCancel() {
    this.close();
    this.$emit('cancel');
  }

  dealStr() {
    this.item = this.item.replace(/[\n\r ()+,|，]/g, ',');
    this.item = this.item.replaceAll(',,', ',');
  }

  openResult() {
    Functions.excelMaker({
      columns: [
        { header: '货号', key: 'productCode', width: 15 },
        { header: '错误信息', key: 'content', width: 100 },
      ],
      data: this.errorReason,
      name: '失败原因',
    });
  }

  renderContent(h: CreateElement): VNode {
    return (
      <div class="r-mx-24 r-mb-12">
        <div>
          <span class="font-size-12 text-grey-12 blockTip">
            1）如商品的价格发生了变化，但在小程序端依然显示变化前价格，请通过本功能进行价格更新；
            <br />
            2）每次最多可放置2000个货号。
          </span>
          <el-input class="r-mt-10" style={!this.updateTime ? 'margin-bottom:18px' : ''} type="textarea" rows="8" disabled={this.loading} v-model={this.item} placeholder="请填写要更新的商品货号，多个时请用逗号隔开" onInput={this.dealStr()} />

          {this.isProcess ? (
            <p class="left line-height-48 flex-inline items-center">
              <i class="el-icon-info text-blue-15 font-size-20" />
              &nbsp; {this.status}
            </p>
          ) : (
            this.updateTime && (
              <p class="left line-height-48 flex-inline items-center">
                <i class="el-icon-info text-blue-15 font-size-20" />
                &nbsp;上次更新时间：&nbsp;{this.updateTime}&nbsp;，成功更新了&nbsp;{this.successNum}&nbsp;条数据，失败&nbsp;{this.failedNum}&nbsp;条
                {this.failedNum > 0 && (
                  <div>
                    ，
                    <span class="scopeSpan text-blue-6" onClick={this.openResult.bind(this)}>
                      点击查看
                    </span>
                    失败原因。
                  </div>
                )}
              </p>
            )
          )}
          <div class="r-mb-10 r-pt-10 border-top-white">
            <el-button class="bg-blue-6 no-border" type="primary" on-click={this.update} disabled={this.loading}>
              开始更新
            </el-button>
            <el-button class="fr" on-click={this.close}>
              关闭
            </el-button>
          </div>
        </div>
      </div>
    );
  }
}
